var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1546_1594)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    transform: "matrix(-1 0 0 1 110 35)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4238 72.76L77.6638 65L85.4238 57.24C85.6089 57.0548 85.7558 56.835 85.856 56.5931C85.9562 56.3511 86.0078 56.0918 86.0078 55.83C86.0078 55.5681 85.9562 55.3088 85.856 55.0669C85.7558 54.825 85.6089 54.6051 85.4238 54.42C85.2386 54.2348 85.0188 54.0879 84.7769 53.9877C84.5349 53.8875 84.2756 53.8359 84.0138 53.8359C83.7519 53.8359 83.4926 53.8875 83.2507 53.9877C83.0088 54.0879 82.7889 54.2348 82.6038 54.42L73.4238 63.6C72.6438 64.38 72.6438 65.64 73.4238 66.42L82.6038 75.6C82.7888 75.7854 83.0086 75.9325 83.2505 76.0328C83.4925 76.1332 83.7518 76.1849 84.0138 76.1849C84.2757 76.1849 84.5351 76.1332 84.777 76.0328C85.019 75.9325 85.2387 75.7854 85.4238 75.6C86.1838 74.82 86.2038 73.54 85.4238 72.76Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1546_1594",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1546_1594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1546_1594",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrowIcon);
export default __webpack_public_path__ + "static/media/leftarrowIcon.557adb0ebc394c333346353cff384b57.svg";
export { ForwardRef as ReactComponent };